import Vue from "vue";
import Component from "vue-class-component";
import { modalHelper, DataItem } from "@/components/modal/modalHelper";
import { Async } from "@/utils/AsyncDecorators";
import { Watch } from "vue-property-decorator";
import Form from "./form.vue";
import { usersStore } from "../store/users.store";
import { applyArrayChanges } from "@/utils/ApplyArrayChange";
import UtentiItem from "./UtentiItem.vue";
import Invite from "./invite.vue";
import GenerateInternalCredential from "./generateInternalCredential.vue";

@Component({ components: { utenti: UtentiItem } })
export default class Index extends Vue {
  showSearchBar: boolean = false;

  @Async({ async get() { return (await usersStore.getters.getAll()).sort((a,b) => `${a.firstName} ${a.lastName}`.localeCompare(`${b.firstName} ${b.lastName}`)); }, default: [], lazy: true })
  utenti: server.user[];

  filter = {
    text: "",
  };

  selectedUser: server.user = null;

  applyFilter(items: server.user[]): server.user[] {
    return items
      .filter(i => ((i.firstName || "").toLowerCase().indexOf(this.filter.text.toLowerCase()) >= 0)
        || ((i.lastName || "").toLowerCase().indexOf(this.filter.text.toLowerCase()) >= 0)
        || ((i.userName || "").toLowerCase().indexOf(this.filter.text.toLowerCase()) >= 0)
        || ((i.email || "").toLowerCase().indexOf(this.filter.text.toLowerCase()) >= 0));
  }

  @Watch("filter.text")
  change(n: string, o: string): void {
    this.showsize = 20;
  }
  showsize: number = 20;

  get areeOrdered(): server.user[] {
    if (this.utenti && this.utenti.length <= 0) { return []; }
    return this.applyFilter(this.utenti)
      .slice(0, this.showsize);
  }

  async edit(item: server.user): Promise<void> {
    this.selectedUser = item;
    try {
      if (item.email) {
        const result: DataItem<server.user> = await modalHelper.showModal<server.user>(Form, Object.assign({}, item));
        applyArrayChanges([result], this.utenti, (a, b) => a.id === b.id);
      } else {
        const result: DataItem<server.user> = await modalHelper.showModal<server.user>(GenerateInternalCredential, Object.assign({}, item));
        applyArrayChanges([result], this.utenti, (a, b) => a.id === b.id);
      }
    } catch { }
    this.selectedUser = null;
  }

  async invite() {
    try {
      let result: DataItem<server.user> = await modalHelper.showModal<server.user>(Invite, {});
      applyArrayChanges([result], this.utenti, (a, b) => a.id === b.id);
    } catch { }
  }

  async generateInternalUser() {
    try {
      let result: DataItem<server.user> = await modalHelper.showModal<server.user>(GenerateInternalCredential, {});
      applyArrayChanges([result], this.utenti, (a, b) => a.id === b.id);
    } catch { }
  }

}